import { render } from "./ContactUs.vue?vue&type=template&id=22eedc76&scoped=true&ts=true"
import script from "./ContactUs.vue?vue&type=script&lang=ts"
export * from "./ContactUs.vue?vue&type=script&lang=ts"

import "./ContactUs.vue?vue&type=style&index=0&id=22eedc76&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22eedc76"]])

export default __exports__